import React from 'react';
import CustomButton from '../../../shared/custom-button/custom-button';
import { useStores } from '../../../store';
import { useNavigate } from 'src/utils/use-navigate';
import { EventType } from '../../../../dtos/analytics.dto';
import { TooltipDisableReason } from '../../../shared/tooltip-disable-message/tooltip-disable-reason';
import { MAINTENANCE_ALERT } from '../../../../utils/constants';
import { BackToPolicySelection } from '../../../shared/back-to-policy-selection/back-to-policy-selection';

interface PolicyActionButtonsProps {
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
    setIsApply: (apply: boolean) => void;
    closeModal: () => void;
    buttonLocation: string;
}

export const PolicyActionButtons: React.FC<PolicyActionButtonsProps> = ({
                                                                            isLoading,
                                                                            setIsLoading,
                                                                            setIsApply,
                                                                            closeModal,
                                                                            buttonLocation
                                                                        }) => {
    const { fwVersionStore, customerStore } = useStores();
    const navigate = useNavigate();

    const editPolicy = () => {
        fwVersionStore.sendGeneralEvent(EventType.LinkClicked, { button: 'editPolicy', location: buttonLocation });
        closeModal();
        const versionPath = `version/${fwVersionStore.draftVersion?.externalId}/${fwVersionStore.versionProtectionPath}`;
        navigate(`/${customerStore.customerId}/${customerStore.serviceId}/protection/${versionPath}`, { replace: true });
    };

    const applyPolicy = async () => {
        fwVersionStore.sendGeneralEvent(EventType.LinkClicked, { button: 'applyPolicy', location: buttonLocation });
        setIsLoading(true);
        await fwVersionStore.commitAndPushVersion({ policyName: '', policyComments: 'Policy Applied' });
        setIsLoading(false);
        setIsApply(true);
    };

    return (
        <div className="policy-footer">
            { buttonLocation === 'quickStartModal' && <BackToPolicySelection buttonLocation={buttonLocation} />}
            <div className="policy-action-btn-wrapper">
                <CustomButton
                    isDisabled={isLoading}
                    className="secondary-btn btn-edit"
                    label="Edit Policy"
                    onClick={editPolicy}
                />
                <TooltipDisableReason overlayClassName="disable-tooltip" disableReason={!customerStore.isAvailable ? MAINTENANCE_ALERT : ''}>
                    <CustomButton
                        className={`primary-btn btn-apply ${isLoading ? 'loading' : ''}`}
                        label="Apply Policy"
                        onClick={applyPolicy}
                        isDisabled={isLoading || !customerStore.isAvailable}
                    />
                </TooltipDisableReason>

            </div>
        </div>
    );
};